import { Box, IconButton, Stack } from "@mui/joy";
import { Outlet, useLocation } from "react-router";

import { motion } from "framer-motion";
import { useEffect, useRef } from "react";



export default function LKPageSurveyor() {
    const location = useLocation();

    useEffect(() => {
      // Выполняется каждый раз, когда изменяется текущий путь
      console.log("Путь изменился на:", location.pathname);
  
      // Вы можете добавить дополнительные действия здесь
    }, [location]);

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки
    
    return (
        <Box sx={{ display: 'flex', 
            // height: '100dvh' 
        }}>
            {/* <Sidebar/> */}
            
            <Box
                ref={scrollContainerRef}
                sx={{
                    // overflow: 'auto',
                    height: '100%',
                    width: '100%'
                }}
            >
                {/* <HeaderLK/> */}

                <Box
                    className="MainContent"
                    sx={{
                        // px: { xs: 2, md: 6 },
                        // mt: {
                        //     xs: 2,
                        //     md: 3,
                        // },
                        // pb: { xs: 2, sm: 2, md: 3 },
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                    }}
                >
                    <motion.main
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                    >
                        <Outlet context={{ scrollContainerRef }}/>
                    </motion.main>
                </Box>
            </Box>
        </Box>
    );
}